import { REPORTS_ACTION_TYPES } from '../../actions/reports/reports_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    values: {},
    filters: {}
};

export const dailyReports = (state = initialState, action) => {
    switch (action.type) {
        case REPORTS_ACTION_TYPES.GET_DAILY_REPORTS_SUCCESS:
            return { ...state, collection: action.payload };
        case REPORTS_ACTION_TYPES.UPDATE_DAILY_REPORTS_PAGINATION:
            return { ...state, ...action.payload };
        case REPORTS_ACTION_TYPES.GET_DAILY_REPORTS_VALUES:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
